import { render, staticRenderFns } from "./apartment-location-info.vue?vue&type=template&id=52baea4e&scoped=true&"
import script from "./apartment-location-info.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-info.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-info.scss?vue&type=style&index=0&id=52baea4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52baea4e",
  null
  
)

export default component.exports